export const CLEANING_STARTS = 'CLEANING_STARTS';
export const CLEANING_STOPS = 'CLEANING_STOPS';
export const GET_UNVERIFIED_CUSTOMERS = 'GET_UNVERIFIED_CUSTOMERS';

export const GET_PAYMENT_HISTORY = 'GET_PAYMENT_HISTORY';
